module.exports = __webpack_public_path__ + "media/images/landkit/icons/social/facebook-11c88aeee94a5e898655149c4ac4ad0e.svg";